import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

import { Loader } from "../styled";

export const BigLoader = styled(Loader)`
    box-sizing: border-box;
    width: 7.5rem;
    height: 7.5rem;
    border-width: 10px;
`;

export const StyledContainer = styled.div`
    width: 100%;
    min-height: 320px;
`;

export const StyledInnerContainer = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    transform: translate(-50%, -50%);
`;

export const StyledTextContainer = styled.div`
    width: 40rem;
    margin-top: 5rem;
    @media ${breakpoints.sm} {
        width: 30rem;
        margin-top: 2.4rem;
    }

    p {
        font-size: var(--size-18);
        line-height: 2.5rem;
        color: var(--color-grey-900);
        text-align: center;
        @media ${breakpoints.sm} {
            font-size: var(--size-14);
        }
    }
`;
